import { fromJS } from 'immutable'
import {
  SHOW_MANUAL_SALE_PRODUCT,
  CLOSE_MANUAL_SALE_PRODUCT,
} from '../../actions/sale-product/types'

const init = fromJS({
  isFetching: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SHOW_MANUAL_SALE_PRODUCT:
      return state
        .set('isFetching', true)
        .set('isOpen', true)
    case CLOSE_MANUAL_SALE_PRODUCT:
      return state
        .set('isFetching', false)
        .set('isOpen', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-manual-reducer.js